import React from 'react';
import { CustomLinkProps } from '../CustomNextLink';
import { BRAND } from '../../constants/main';
import { LinkStyledAC } from './AC/LinkStyled.AC';
import { LinkStyledAP } from './AP/LinkStyled.AP';
import { LinkStyledDS } from './DS/LinkStyled.DS';
import { LinkStyledOV } from './OV/LinkStyled.OV';
import { LinkStyled } from './LinkStyled';
import { SC } from '../../styles/theme';

export interface LinkProps extends SC, Omit<CustomLinkProps, 'children'> {
    icon?: any;
}

const Link = (props: LinkProps) => {
    if (BRAND === 'AC') return <LinkStyledAC {...props} />;
    if (BRAND === 'AP') return <LinkStyledAP {...props} />;
    if (BRAND === 'DS') return <LinkStyledDS {...props} />;
    if (BRAND === 'OV') return <LinkStyledOV {...props} />;
    return <LinkStyled {...props} />;
};

export default Link;
